import { createAction, props } from '@ngrx/store';
export enum UserActionTypes {
    initUser = '[User] init user',
    getUser = '[User] get user',
    getUserSuccess = '[User] get user success',
    getUserFailure = '[User] get user failure',
    clearUser = '[User] clear user',
}
export const InitUser = createAction(UserActionTypes.initUser);
export const GetUser = createAction(UserActionTypes.getUser, props<{ userId: string }>());
export const GetUserSuccess = createAction(UserActionTypes.getUserSuccess, props<any>());
export const GetUserFailures = createAction(UserActionTypes.getUserFailure, props<any>());

export const ClearUser = createAction(UserActionTypes.clearUser);
